import Dynamic from 'next/dynamic';
import { Backdrop } from '@mui/material';
import SkeletonFullComponent from 'components/SchoolsComponents/SchoolGalleryComponent/SkeletonFull';

export const LabelWithDescriptionComponent = Dynamic(
  () => import('components/SchoolsComponents/LabelWithDescriptionComponent'),
  { ssr: true }
);

export const SchoolBreadcrumbComponent = Dynamic(
  () => import('components/SchoolsComponents/SchoolBreadcrumbComponent'),
  { ssr: true }
);

export const SchoolGalleryComponent = Dynamic(
  () => import('components/SchoolsComponents/SchoolGalleryComponent'),
  {
    ssr: false,
    loading: () => (
      <Backdrop sx={{ zIndex: 1201 }}>
        <SkeletonFullComponent />
      </Backdrop>
    ),
  }
);

export const ServicesIDComponent = Dynamic(
  () => import('components/SchoolsComponents/ServicesIDComponent'),
  { ssr: true }
);

export const VideoComponent = Dynamic(
  () => import('components/SchoolsComponents/VideoComponent'),
  { ssr: false }
);

export const SchoolLocationComponent = Dynamic(
  () => import('components/SchoolsComponents/SchoolLocationComponent'),
  { ssr: true }
);

export const SchoolRatingComponent = Dynamic(
  () => import('components/SchoolsComponents/SchoolRatingComponent'),
  { ssr: true }
);

export const SchoolTestimoniesComponent = Dynamic(
  () => import('components/SchoolsComponents/SchoolTestimoniesComponent'),
  { ssr: true }
);

export const BuildPackageComponent = Dynamic(
  () => import('components/SchoolsComponents/BuildPackageComponent'),
  { ssr: true }
);

export const StepsComponent = Dynamic(
  () => import('components/SchoolsComponents/StepsComponent'),
  { ssr: true }
);
